'use strict';

module Patersons {    

    export class CashHighInterestHoldingsReportComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/cashHighInterestHoldingsReport.component.html';
        bindings: any = {
            title: '@',
            report: '<',
            predicate: '<',
            sortOrder: '<',
            searchText: '<',
            onOrderChanged: '&'
        };
    }
}